import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from './http-server';
import axiosInstanceP from './http-server-parent';
// const baseUrl = 'https://tms-api.htptv.net';
const baseUrl = process.env.REACT_APP_BASE_URL;

const get = (url: string, signal?: AbortSignal) => {
  return axiosInstance.get(baseUrl + `${url}`, { signal });
};
const getParent = (url: string, signal?: AbortSignal) => {
  return axiosInstanceP.get(baseUrl + `${url}`, { signal });
};
const deleteData = (url: string, userId: string) => {
  return axiosInstance.delete(baseUrl + `${url}`, {
    data: { userId },
  });
};

const deleteShift = (url: string, data?: any) => {
  return axiosInstance.delete(baseUrl + `${url}`, { data });
};

const post = (url: string, data?: any) => {
  return axiosInstance.post(baseUrl + url, data);
};
const postParent = (url: string, data?: any) => {
  return axiosInstanceP.post(baseUrl + url, data);
};
const put = (url: string, data?: any) => {
  return axiosInstance.put(baseUrl + url, data);
};
const postImage = (url: string, data: any) => {
  return axiosInstance.post(baseUrl + url, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
const postdoc = (url: string, data: any) => {
  return axiosInstance.post(baseUrl + url, data, {
    responseType: 'blob',
  });
};
const patch = (url: string, data: any) => {
  return axiosInstance.patch(baseUrl + url, data);
};
const patchRequest = (url: string) => {
  return axiosInstance.patch(baseUrl + url);
};
const HttpService = {
  get,
  deleteData,
  put,
  postImage,
  postdoc,
  post,
  patch,
  deleteShift,
  getParent,
  postParent,
  patchRequest
};

export default HttpService;
